<template>
  <div class="hourly-vacancy-container" :class="{ 'long': vacancies.length > 1 }">
    <template v-if="typeof vacancies[0]?.vacancy === 'number'">
      <h3 v-if="!isPrepaidFlow && isLoaded" class="hourly-space">
        {{ $t('hourly_space_vacancy') }} -
        <span v-for="hourlyVacancy in vacancies" :key="hourlyVacancy.place_id" class="hourly-space-item">
          {{ hourlyVacancy.short_name }}{{ hourlyVacancy.short_name ? ":" : "" }}{{'\xa0'}}{{ hourlyVacancy.vacancy ? hourlyVacancy.vacancy : $t('full') }}
        </span>
      </h3>
    </template>
    <template v-else>
      <h3 v-if="!isPrepaidFlow && isLoaded" class="hourly-space">
        {{ $t('hourly_space_vacancy') }} -
        <span v-for="hourlyVacancy in vacancies" :key="hourlyVacancy.place_id" class="hourly-space-item">
          {{ hourlyVacancy.short_name }}{{ hourlyVacancy.short_name ? ":" : "" }}{{'\xa0'}}{{ hourlyVacancy.hourly ? hourlyVacancy.hourly : $t('full') }}
        </span>
      </h3>
      <h3 v-if="!isPrepaidFlow && isLoaded" class="hourly-space">
        {{ $t('total_space_vacancy') }} -
        <span v-for="hourlyVacancy in vacancies" :key="hourlyVacancy.place_id" class="hourly-space-item">
          {{ hourlyVacancy.short_name }}{{ hourlyVacancy.short_name ? ":" : "" }}{{'\xa0'}}{{ hourlyVacancy.total ? hourlyVacancy.total : $t('full') }}
        </span>
      </h3>
    </template>
  </div>
</template>

<script>
import qs from 'qs';
import { base } from '@/axios-api';

export default {
  name: "HourlyVacancy",
  data() {
    return {
      vacancies: [],
      isLoaded: false,
      requestInterval: null,
      audio: null,
      alertInterval: null,
    };
  },
  computed: {
    placesIds() {
      return this.$store.getters['app/places'];
    },
    isPrepaidFlow() {
      return this.$store.getters["app/isPrepaidFlow"];
    },
    alertThreshold() {
      return this.$store.state.app.places[0]?.features?.soundAlertHourly;
    },
    hourlyVacancy() {
      return this.vacancies[0]?.hourly;
    }
  },
  watch: {
    hourlyVacancy(newValue) {
      if (newValue === 'number' && newValue <= this.alertThreshold) {
        this.turnOnSoundAlert();
      } else {
        this.turnOffSoundAlert();
      }
    }
  },
  methods: {
    getHourlyVacancies() {
      base({
        url: "/places/vacancy",
        method: "GET",
        params: {
          place_id: this.placesIds,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, {
            arrayFormat: "repeat",
          });
        },
      })
        .then((response) => {
          this.vacancies = response.data.body;
          this.isLoaded = true;
        })
    },
    turnOnSoundAlert() {
      this.alertInterval = setInterval(() => {
        this.audio.play();
      }, 4000);
    },
    turnOffSoundAlert() {
      if (this.alertInterval) {
        clearInterval(this.alertInterval);
        this.alertInterval = null;
      }
    }
  },
  created() {
    this.audio = new Audio(require('@/assets/sounds/bell-notification.wav'));
    this.audio.volume = 1;
    this.getHourlyVacancies();
    this.requestInterval = setInterval(() => {
      this.getHourlyVacancies();
    }, 5000)
  },
  beforeDestroy() {
    clearInterval(this.requestInterval);
    this.requestInterval = null;
    this.turnOffSoundAlert();
  },
}
</script>

<style scoped lang="scss">
.hourly-vacancy-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.hourly-space {
  @media screen and (max-width: 1440px){
    font-size: 16px;
  }
  @media screen and (max-width: 960px){
    font-size: 14px;
    max-width: 60%;
    text-align: left;
    justify-self: flex-start;
  }
}

.long .hourly-space {
  font-size: 16px;
  @media screen and (max-width: 1440px){
    font-size: 14px;
  }
  @media screen and (max-width: 960px){
    font-size: 12px;
    max-width: 60%;
    text-align: left;
    justify-self: flex-start;
  }
}
.hourly-space-item {
  text-transform: uppercase;
}

.hourly-space {
  white-space: nowrap;
}
</style>
